var _defs, _polygon, _polygon2, _polygon3, _polygon4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "game",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:url(#linear-gradient-2);}.cls-3{fill:url(#linear-gradient-3);}.cls-4{fill:url(#linear-gradient-4);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 21.28,
    y1: 78.88,
    x2: 63.06,
    y2: 19.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00ff80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#09ff83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#21ff8b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#49ff97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#64ffa0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 64.03,
    y1: 110.09,
    x2: 105.81,
    y2: 50.42,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 70.01,
    y1: 117.18,
    x2: 109.01,
    y2: 61.48,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 18.14,
    y1: 67.73,
    x2: 57.14,
    y2: 12.03,
    xlinkHref: "#linear-gradient"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "vGame") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "44.8 0 44.8 8.53 53.33 8.53 56.61 8.53 74.67 8.53 74.67 32.21 64 42.88 53.33 32.21 53.33 17.07 44.8 17.07 44.8 35.75 64 54.95 83.2 35.75 83.2 0 44.8 0"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "74.67 119.47 71.93 119.47 53.33 119.47 53.33 95.78 64 85.12 74.67 95.78 74.67 110.93 83.2 110.93 83.2 92.25 64 73.05 44.8 92.25 44.8 128 83.2 128 83.2 119.47 74.67 119.47"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "119.47 44.8 119.47 53.33 119.47 57.63 119.47 74.67 95.79 74.67 85.12 64 95.79 53.33 110.93 53.33 110.93 44.8 92.25 44.8 73.05 64 92.25 83.2 128 83.2 128 44.8 119.47 44.8"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "35.75 44.8 0 44.8 0 83.2 8.53 83.2 8.53 74.67 8.53 70.04 8.53 53.33 32.21 53.33 42.88 64 32.21 74.67 17.07 74.67 17.07 83.2 35.75 83.2 54.95 64 35.75 44.8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGame);
export default __webpack_public_path__ + "static/media/game.aa122fa2f245da63185f928d595d9406.svg";
export { ForwardRef as ReactComponent };